import { createContext as e, useCallback as t, useContext as n, useEffect as r, useId as i, useLayoutEffect as a, useMemo as o, useRef as s, useState as c } from "react";
import { jsx as l, jsxs as u } from "react/jsx-runtime";
import { createPortal as d } from "react-dom";
import { X as f } from "lucide-react";
// src/theme/ThemeRoot.tsx
var p = e({
	theme: "dark",
	fontSize: "medium",
	layout: "app"
}), m = () => n(p);
function h() {
	let [e, t] = c(() => typeof window < "u" && typeof window.matchMedia == "function" ? window.matchMedia("(prefers-color-scheme: dark)").matches : !0);
	return r(() => {
		var e;
		if (typeof window > "u" || typeof window.matchMedia != "function") return;
		let n = window.matchMedia("(prefers-color-scheme: dark)"), r = () => t(n.matches);
		return (e = n.addEventListener) == null || e.call(n, "change", r), () => {
			var e;
			return (e = n.removeEventListener) == null ? void 0 : e.call(n, "change", r);
		};
	}, []), e;
}
var g = "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap";
function _() {
	if (typeof document > "u" || document.querySelector("link[data-nb-fonts]")) return;
	let e = document.createElement("link");
	e.rel = "stylesheet", e.href = g, e.setAttribute("data-nb-fonts", ""), document.head.appendChild(e);
}
function v({ theme: e = "dark", fontSize: t = "medium", layout: n = "app", portalContainer: i, loadFonts: a, className: s, style: c, children: u }) {
	let d = h(), f = e === "auto" ? d ? "dark" : "light" : e;
	r(() => {
		a && _();
	}, [a]);
	let m = o(() => ({
		theme: f,
		fontSize: t,
		layout: n,
		portalContainer: i
	}), [
		f,
		t,
		n,
		i
	]);
	return /* @__PURE__ */ l(p.Provider, {
		value: m,
		children: /* @__PURE__ */ l("div", {
			className: ["nb-root", s].filter(Boolean).join(" "),
			"data-theme": f,
			"data-font-size": t === "medium" ? void 0 : t,
			"data-layout": n,
			style: c,
			children: u
		})
	});
}
function y() {
	let e = m();
	return {
		className: "nb-root nb-portal",
		"data-theme": e.theme,
		"data-font-size": e.fontSize === "medium" ? void 0 : e.fontSize,
		"data-layout": e.layout
	};
}
// src/ui/Portal.tsx
function b({ children: e, container: t }) {
	let { portalContainer: n } = m(), r = t == null ? n : t, i = y(), [o, s] = c(null);
	return a(() => {
		let e = r == null ? typeof document < "u" ? document.body : null : r;
		if (!e) return;
		let t = document.createElement("div");
		for (let [e, n] of Object.entries(i)) n != null && t.setAttribute(e === "className" ? "class" : e, n);
		return t.style.background = "transparent", e.appendChild(t), s(t), () => {
			e.removeChild(t), s(null);
		};
	}, [
		r,
		i["data-theme"],
		i["data-font-size"]
	]), o ? d(e, o) : null;
}
// src/ui/Toast.tsx
var x = e(() => {}), S = () => n(x);
function C({ children: e, duration: n = 2500 }) {
	let [r, i] = c([]), a = s(0), d = t((e, t = "info") => {
		let r = ++a.current;
		i((n) => [...n, {
			id: r,
			text: e,
			kind: t
		}]), setTimeout(() => i((e) => e.filter((e) => e.id !== r)), n);
	}, [n]), f = o(() => d, [d]);
	return /* @__PURE__ */ u(x.Provider, {
		value: f,
		children: [e, r.length > 0 && /* @__PURE__ */ l(b, { children: /* @__PURE__ */ l("div", {
			className: "nb-toasts",
			role: "status",
			"aria-live": "polite",
			children: r.map((e) => /* @__PURE__ */ l("div", {
				className: `nb-toast nb-toast-${e.kind}`,
				children: e.text
			}, e.id))
		}) })]
	});
}
// src/ui/IconButton.tsx
function w({ label: e, active: t, badge: n, className: r, children: i, type: a = "button", ...o }) {
	return /* @__PURE__ */ u("button", {
		type: a,
		className: [
			"nb-iconbtn",
			t ? "nb-active" : "",
			r
		].filter(Boolean).join(" "),
		"aria-label": e,
		title: e,
		"aria-pressed": t,
		...o,
		children: [i, n != null && n !== 0 && n !== "" && /* @__PURE__ */ l("span", {
			className: "nb-badge",
			children: n
		})]
	});
}
// src/ui/Drawer.tsx
function T({ open: e, onClose: t, side: n = "right", title: i, actions: a, width: o, children: s, closeLabel: c = "Close" }) {
	return r(() => {
		if (!e) return;
		let n = (e) => {
			e.key === "Escape" && t();
		};
		return document.addEventListener("keydown", n), () => document.removeEventListener("keydown", n);
	}, [e, t]), e ? /* @__PURE__ */ l(b, { children: /* @__PURE__ */ l("div", {
		className: "nb-drawer-backdrop",
		onMouseDown: (e) => e.target === e.currentTarget && t(),
		children: /* @__PURE__ */ u("aside", {
			className: `nb-drawer nb-drawer-${n}`,
			role: "dialog",
			"aria-modal": "true",
			style: { width: o },
			children: [/* @__PURE__ */ u("div", {
				className: "nb-drawer-head",
				children: [/* @__PURE__ */ l("span", { children: i }), /* @__PURE__ */ u("span", {
					style: {
						display: "flex",
						gap: 8,
						alignItems: "center"
					},
					children: [a, /* @__PURE__ */ l(w, {
						label: c,
						onClick: t,
						children: /* @__PURE__ */ l(f, { size: 18 })
					})]
				})]
			}), /* @__PURE__ */ l("div", {
				className: "nb-drawer-body",
				children: s
			})]
		})
	}) }) : null;
}
// src/ui/Spinner.tsx
function E({ size: e = 18, label: t }) {
	return /* @__PURE__ */ l("span", {
		className: "nb-spinner",
		role: "status",
		"aria-label": t == null ? "Loading" : t,
		style: {
			width: e,
			height: e
		}
	});
}
// src/ui/Button.tsx
function D({ variant: e = "primary", size: t = "md", loading: n, icon: r, className: i, children: a, disabled: o, type: s = "button", ...c }) {
	return /* @__PURE__ */ u("button", {
		type: s,
		className: [
			"nb-btn",
			`nb-btn-${e}`,
			t === "sm" ? "nb-btn-sm" : "",
			i
		].filter(Boolean).join(" "),
		disabled: o || n,
		...c,
		children: [n ? /* @__PURE__ */ l(E, {}) : r, a]
	});
}
// src/ui/Dialog.tsx
function O({ open: e, onClose: t, title: n, children: i, footer: a, maxWidth: o, closeLabel: c = "Close" }) {
	let d = s(null);
	return r(() => {
		var n;
		if (!e) return;
		let r = (e) => {
			e.key === "Escape" && t();
		};
		return document.addEventListener("keydown", r), (n = d.current) == null || n.focus(), () => document.removeEventListener("keydown", r);
	}, [e, t]), e ? /* @__PURE__ */ l(b, { children: /* @__PURE__ */ l("div", {
		className: "nb-backdrop",
		onMouseDown: (e) => e.target === e.currentTarget && t(),
		children: /* @__PURE__ */ u("div", {
			className: "nb-dialog",
			role: "dialog",
			"aria-modal": "true",
			tabIndex: -1,
			ref: d,
			style: o == null ? void 0 : { "--nb-dialog-max": typeof o == "number" ? `${o}px` : o },
			children: [
				/* @__PURE__ */ u("div", {
					className: "nb-dialog-head",
					children: [/* @__PURE__ */ l("span", { children: n }), /* @__PURE__ */ l(w, {
						label: c,
						onClick: t,
						children: /* @__PURE__ */ l(f, { size: 18 })
					})]
				}),
				/* @__PURE__ */ l("div", {
					className: "nb-dialog-body",
					children: i
				}),
				a && /* @__PURE__ */ l("div", {
					className: "nb-dialog-foot",
					children: a
				})
			]
		})
	}) }) : null;
}
// src/ui/Select.tsx
function k({ label: e, options: t, placeholder: n, onChange: r, className: i, ...a }) {
	var o;
	let s = /* @__PURE__ */ new Map();
	for (let e of t) s.set(e.group, [...(o = s.get(e.group)) == null ? [] : o, e]);
	let c = (e) => e.map((e) => /* @__PURE__ */ l("option", {
		value: e.value,
		disabled: e.disabled,
		children: e.label
	}, e.value)), d = /* @__PURE__ */ u("select", {
		className: ["nb-select", i].filter(Boolean).join(" "),
		onChange: (e) => r == null ? void 0 : r(e.target.value),
		...a,
		children: [n && /* @__PURE__ */ l("option", {
			value: "",
			disabled: !0,
			children: n
		}), [...s.entries()].map(([e, t]) => e ? /* @__PURE__ */ l("optgroup", {
			label: e,
			children: c(t)
		}, e) : c(t))]
	});
	return e ? /* @__PURE__ */ u("label", {
		className: "nb-field",
		children: [/* @__PURE__ */ l("span", { children: e }), d]
	}) : d;
}
// src/ui/Switch.tsx
function A({ checked: e, onChange: t, label: n, disabled: r }) {
	return /* @__PURE__ */ u("button", {
		type: "button",
		role: "switch",
		"aria-checked": e,
		className: "nb-switch",
		disabled: r,
		onClick: () => t(!e),
		children: [/* @__PURE__ */ l("span", { className: "nb-switch-track" }), n && /* @__PURE__ */ l("span", { children: n })]
	});
}
// src/report/format.ts
var j = (e) => typeof e == "number" && Number.isFinite(e), M = (e, t = 2) => j(e) ? Number.isInteger(e) ? e.toLocaleString() : e.toLocaleString(void 0, { maximumFractionDigits: t }) : "";
function N(e, t = !0) {
	if (e == null) return "";
	if (typeof e == "string") return e;
	if (typeof e == "number") return t ? M(e, 4) : String(e);
	if (typeof e == "boolean") return e ? "true" : "false";
	if (e instanceof Date) return e.toISOString();
	if (Array.isArray(e)) return JSON.stringify(e);
	if (typeof e == "object") {
		let t = e;
		if ("days" in t || "hours" in t || "minutes" in t || "seconds" in t) {
			let e = [];
			return t.days && e.push(`${t.days}d`), t.hours && e.push(`${t.hours}h`), t.minutes && e.push(`${t.minutes}m`), t.seconds && e.push(`${t.seconds}s`), t.milliseconds && e.push(`${t.milliseconds}ms`), e.join(" ") || "0";
		}
		try {
			return JSON.stringify(e);
		} catch {
			return String(e);
		}
	}
	return String(e);
}
var P = (e, t) => t && t.length ? t : [...new Set(e.flatMap((e) => Object.keys(e == null ? {} : e)))];
function F(e, t) {
	return e == null && t == null ? 0 : e == null ? 1 : t == null ? -1 : typeof e == "number" && typeof t == "number" ? e - t : String(e).localeCompare(String(t), void 0, {
		numeric: !0,
		sensitivity: "base"
	});
}
// src/ui/Chip.tsx
function I({ selected: e, size: t = "md", icon: n, onClick: r, className: i, children: a, disabled: o, ...s }) {
	let c = [
		"nb-chip",
		e ? "nb-selected" : "",
		t === "sm" ? "nb-chip-sm" : "",
		r ? "nb-clickable" : "",
		i
	].filter(Boolean).join(" ");
	return r ? /* @__PURE__ */ u("button", {
		type: "button",
		className: c,
		onClick: r,
		disabled: o,
		"aria-pressed": e,
		...s,
		children: [n, a]
	}) : /* @__PURE__ */ u("span", {
		className: c,
		children: [n, a]
	});
}
// src/ui/TextField.tsx
function L({ label: e, error: t, hint: n, multiline: r, className: i, ...a }) {
	let o = r ? /* @__PURE__ */ l("textarea", {
		className: ["nb-textarea", i].filter(Boolean).join(" "),
		...a
	}) : /* @__PURE__ */ l("input", {
		className: ["nb-input", i].filter(Boolean).join(" "),
		...a
	});
	return /* @__PURE__ */ u("label", {
		className: "nb-field",
		children: [
			e && /* @__PURE__ */ l("span", { children: e }),
			o,
			t && /* @__PURE__ */ l("span", {
				className: "nb-input-error",
				children: t
			}),
			n && !t && /* @__PURE__ */ l("span", {
				style: {
					fontSize: "0.85em",
					opacity: .7
				},
				children: n
			})
		]
	});
}
// src/ui/Menu.tsx
function R({ label: e, items: n, badge: a, children: o, className: d }) {
	let [f, p] = c(!1), m = s(null), h = s(null), g = i(), _ = t((e = !1) => {
		var t;
		p(!1), e && ((t = m.current) == null || (t = t.querySelector("button")) == null || t.focus());
	}, []);
	return r(() => {
		if (!f) return;
		let e = (e) => {
			var t;
			(t = m.current) != null && t.contains(e.target) || p(!1);
		}, t = (e) => {
			e.key === "Escape" && (e.stopPropagation(), _(!0));
		};
		return document.addEventListener("pointerdown", e, !0), document.addEventListener("keydown", t, !0), () => {
			document.removeEventListener("pointerdown", e, !0), document.removeEventListener("keydown", t, !0);
		};
	}, [f, _]), r(() => {
		var e;
		f && ((e = h.current) == null || (e = e.querySelector("button:not(:disabled)")) == null || e.focus());
	}, [f]), /* @__PURE__ */ u("div", {
		className: ["nb-menu", d].filter(Boolean).join(" "),
		ref: m,
		children: [/* @__PURE__ */ u("button", {
			type: "button",
			className: "nb-iconbtn",
			"aria-label": e,
			title: e,
			"aria-haspopup": "menu",
			"aria-expanded": f,
			"aria-controls": f ? g : void 0,
			onClick: () => p((e) => !e),
			children: [o, a != null && a !== 0 && a !== "" && /* @__PURE__ */ l("span", {
				className: "nb-badge",
				children: a
			})]
		}), f && /* @__PURE__ */ l("div", {
			className: "nb-menu-list",
			id: g,
			role: "menu",
			ref: h,
			onKeyDown: (e) => {
				var t, n, r;
				if (![
					"ArrowDown",
					"ArrowUp",
					"Home",
					"End"
				].includes(e.key)) return;
				e.preventDefault();
				let i = [...(t = (n = h.current) == null ? void 0 : n.querySelectorAll("button:not(:disabled)")) == null ? [] : t];
				if (i.length === 0) return;
				let a = i.indexOf(document.activeElement);
				(r = i[e.key === "Home" ? 0 : e.key === "End" ? i.length - 1 : e.key === "ArrowDown" ? (a + 1) % i.length : (a - 1 + i.length) % i.length]) == null || r.focus();
			},
			children: n.map((e) => /* @__PURE__ */ u("button", {
				type: "button",
				role: "menuitem",
				className: "nb-menu-item",
				disabled: e.disabled,
				"aria-busy": e.busy || void 0,
				onClick: () => {
					_(), e.onSelect();
				},
				children: [
					e.icon && /* @__PURE__ */ l("span", {
						className: "nb-menu-icon",
						children: e.icon
					}),
					/* @__PURE__ */ l("span", {
						className: "nb-menu-label",
						children: e.label
					}),
					e.badge != null && e.badge !== 0 && e.badge !== "" && /* @__PURE__ */ l("span", {
						className: "nb-badge nb-menu-badge",
						children: e.badge
					})
				]
			}, e.key))
		})]
	});
}
// src/ui/Tooltip.tsx
function z({ text: e, children: t }) {
	return /* @__PURE__ */ l("span", {
		className: "nb-tip",
		"data-tip": e,
		children: t
	});
}
// src/ui/Table.tsx
function B({ columns: e, rows: t, rowKey: n, sortable: r = !0, empty: i, maxHeight: a, onRowClick: s }) {
	let [d, f] = c(null), p = o(() => {
		if (!d) return t;
		let n = e.find((e) => e.key === d.key), r = (e) => n != null && n.sortValue ? n.sortValue(e) : e[d.key];
		return [...t].sort((e, t) => (d.asc ? 1 : -1) * F(r(e), r(t)));
	}, [
		t,
		d,
		e
	]);
	return !t.length && i ? /* @__PURE__ */ l("div", {
		className: "nb-empty",
		children: i
	}) : /* @__PURE__ */ l("div", {
		className: "nb-tablewrap",
		style: { maxHeight: a },
		children: /* @__PURE__ */ u("table", {
			className: "nb-table",
			children: [/* @__PURE__ */ l("thead", { children: /* @__PURE__ */ l("tr", { children: e.map((e) => /* @__PURE__ */ l("th", {
				className: [
					e.align === "right" ? "nb-num" : "",
					(d == null ? void 0 : d.key) === e.key ? "nb-sorted" : "",
					(d == null ? void 0 : d.key) === e.key && !d.asc ? "nb-desc" : ""
				].filter(Boolean).join(" "),
				style: {
					width: e.width,
					cursor: r ? "pointer" : "default"
				},
				onClick: r ? () => f((t) => ({
					key: e.key,
					asc: (t == null ? void 0 : t.key) !== e.key || !t.asc
				})) : void 0,
				children: e.title
			}, e.key)) }) }), /* @__PURE__ */ l("tbody", { children: p.map((t, r) => /* @__PURE__ */ l("tr", {
				onClick: s ? () => s(t) : void 0,
				style: { cursor: s ? "pointer" : void 0 },
				children: e.map((e) => {
					let n = t[e.key];
					return /* @__PURE__ */ l("td", {
						className: [e.align === "right" || typeof n == "number" ? "nb-num" : "", n == null && !e.render ? "nb-null" : ""].filter(Boolean).join(" "),
						children: e.render ? e.render(t, r) : n == null ? "—" : N(n)
					}, e.key);
				})
			}, n ? n(t, r) : r)) })]
		})
	});
}
export { m as C, _ as S, w as _, I as a, b, F as c, A as d, k as f, T as g, E as h, L as i, M as l, D as m, z as n, N as o, O as p, R as r, P as s, B as t, j as u, C as v, v as x, S as y };

//# sourceMappingURL=ui-BYUpyHph.js.map